const config = {
    showLinks: {
        contact: {
            countries: [
                'AR',
                'BR',
                'AW',
                'FK',
                'MS',
                'NI',
                'PM',
                'SH',
                'VC',
                'AG',
                'AI',
                'AN',
                'BB',
                'BM',
                'BO',
                'BS',
                'BZ',
                'CL',
                'CO',
                'CR',
                'DM',
                'DO',
                'GD',
                'GL',
                'GT',
                'GY',
                'HN',
                'JM',
                'KN',
                'KY',
                'LC',
                'NC',
                'PA',
                'PE',
                'SR',
                'SV',
                'TC',
                'TT',
                'VE',
                'EC',
                'GF',
                'GP',
                'MQ',
                'MX',
                'US',
            ],
        },
        privacy: {
            countries: [
                'AR',
                'AT',
                'AU',
                'BE',
                'BR',
                'C2',
                'CA',
                'CH',
                'CN',
                'DE',
                'DK',
                'ES',
                'FR',
                'GB',
                'AZ',
                'BI',
                'BN',
                'BT',
                'BY',
                'CD',
                'CG',
                'CI',
                'CK',
                'CM',
                'DJ',
                'ER',
                'FM',
                'GA',
                'GH',
                'GW',
                'KH',
                'KI',
                'KM',
                'KZ',
                'LA',
                'LK',
                'MD',
                'ME',
                'MH',
                'MK',
                'MN',
                'MR',
                'MU',
                'MV',
                'NE',
                'NF',
                'NG',
                'NP',
                'NR',
                'NU',
                'PN',
                'PY',
                'RW',
                'SB',
                'SJ',
                'SL',
                'SN',
                'SO',
                'ST',
                'TD',
                'TO',
                'TV',
                'UA',
                'VG',
                'VU',
                'WF',
                'WS',
                'YE',
                'ZW',
                'VA',
                'YT',
                'AW',
                'FK',
                'MS',
                'NI',
                'PM',
                'SH',
                'VC',
                'AD',
                'AE',
                'AL',
                'AM',
                'AO',
                'BA',
                'BF',
                'BH',
                'BJ',
                'BW',
                'CV',
                'DZ',
                'ET',
                'FJ',
                'FO',
                'GI',
                'GM',
                'GN',
                'HR',
                'ID',
                'IS',
                'JO',
                'KE',
                'KG',
                'KR',
                'KW',
                'LS',
                'MA',
                'MG',
                'ML',
                'MW',
                'MZ',
                'NA',
                'OM',
                'PF',
                'PG',
                'PW',
                'QA',
                'SA',
                'SC',
                'SZ',
                'TG',
                'TJ',
                'TM',
                'TN',
                'TZ',
                'UG',
                'UY',
                'VN',
                'ZA',
                'ZM',
                'BG',
                'EE',
                'LT',
                'LV',
                'RO',
                'SK',
                'AG',
                'AI',
                'AN',
                'BB',
                'BM',
                'BO',
                'BS',
                'BZ',
                'CL',
                'CO',
                'CR',
                'DM',
                'DO',
                'GD',
                'GL',
                'GT',
                'GY',
                'HN',
                'JM',
                'KN',
                'KY',
                'LC',
                'NC',
                'PA',
                'PE',
                'SR',
                'SV',
                'TC',
                'TT',
                'VE',
                'CY',
                'MY',
                'NZ',
                'PH',
                'CZ',
                'FI',
                'GR',
                'HU',
                'LI',
                'LU',
                'MT',
                'PT',
                'RE',
                'SI',
                'SM',
                'EC',
                'GF',
                'GP',
                'MQ',
                'HK',
                'IE',
                'IL',
                'IN',
                'IT',
                'JP',
                'MX',
                'NL',
                'NO',
                'PL',
                'EG',
                'GE',
                'MC',
                'RS',
                'RU',
                'SE',
                'SG',
                'TH',
                'TR',
                'TW',
                'US',
            ],
        },
        legal: {
            countries: [
                'AR',
                'AT',
                'AU',
                'BR',
                'C2',
                'CA',
                'CH',
                'CN',
                'DE',
                'AZ',
                'BI',
                'BN',
                'BT',
                'BY',
                'CD',
                'CG',
                'CI',
                'CK',
                'CM',
                'DJ',
                'ER',
                'FM',
                'GA',
                'GH',
                'GW',
                'KH',
                'KI',
                'KM',
                'KZ',
                'LA',
                'LK',
                'MD',
                'ME',
                'MH',
                'MK',
                'MN',
                'MR',
                'MU',
                'MV',
                'NE',
                'NF',
                'NG',
                'NP',
                'NR',
                'NU',
                'PN',
                'PY',
                'RW',
                'SB',
                'SJ',
                'SL',
                'SN',
                'SO',
                'ST',
                'TD',
                'TO',
                'TV',
                'UA',
                'VG',
                'VU',
                'WF',
                'WS',
                'YE',
                'ZW',
                'AW',
                'FK',
                'MS',
                'NI',
                'PM',
                'SH',
                'VC',
                'AD',
                'AE',
                'AL',
                'AM',
                'AO',
                'BA',
                'BF',
                'BH',
                'BJ',
                'BW',
                'CV',
                'DZ',
                'ET',
                'FJ',
                'FO',
                'GI',
                'GM',
                'GN',
                'HR',
                'ID',
                'IS',
                'JO',
                'KE',
                'KG',
                'KR',
                'KW',
                'LS',
                'MA',
                'MG',
                'ML',
                'MW',
                'MZ',
                'NA',
                'OM',
                'PF',
                'PG',
                'PW',
                'QA',
                'SA',
                'SC',
                'SZ',
                'TG',
                'TJ',
                'TM',
                'TN',
                'TZ',
                'UG',
                'UY',
                'VN',
                'ZA',
                'ZM',
                'AG',
                'AI',
                'AN',
                'BB',
                'BM',
                'BO',
                'BS',
                'BZ',
                'CL',
                'CO',
                'CR',
                'DM',
                'DO',
                'GD',
                'GL',
                'GT',
                'GY',
                'HN',
                'JM',
                'KN',
                'KY',
                'LC',
                'NC',
                'PA',
                'PE',
                'SR',
                'SV',
                'TC',
                'TT',
                'VE',
                'CY',
                'MY',
                'NZ',
                'PH',
                'EC',
                'GF',
                'GP',
                'MQ',
                'HK',
                'IL',
                'IN',
                'JP',
                'MX',
                'EG',
                'GE',
                'MC',
                'RS',
                'SG',
                'TH',
                'TW',
                'US',
            ],
        },
        worldwide: {
            countries: ['US'],
        },
        about: {
            countries: [
                'AR',
                'BR',
                'AW',
                'FK',
                'MS',
                'NI',
                'PM',
                'SH',
                'VC',
                'AG',
                'AI',
                'AN',
                'BB',
                'BM',
                'BO',
                'BS',
                'BZ',
                'CL',
                'CO',
                'CR',
                'DM',
                'DO',
                'GD',
                'GL',
                'GT',
                'GY',
                'HN',
                'JM',
                'KN',
                'KY',
                'LC',
                'NC',
                'PA',
                'PE',
                'SR',
                'SV',
                'TC',
                'TT',
                'VE',
                'EC',
                'GF',
                'GP',
                'MQ',
                'MX',
            ],
        },
        home: {
            countries: [
                'BE',
                'DK',
                'ES',
                'FR',
                'GB',
                'VA',
                'YT',
                'BG',
                'EE',
                'LT',
                'LV',
                'RO',
                'SK',
                'CZ',
                'FI',
                'GR',
                'HU',
                'LI',
                'LU',
                'MT',
                'PT',
                'RE',
                'SI',
                'SM',
                'IE',
                'IT',
                'NL',
                'NO',
                'PL',
                'SE',
                'TR',
            ],
        },
        imprint: {
            countries: ['AT', 'CH', 'DE'],
        },
        policy: {
            countries: ['US'],
        },
    },
    showCopyright: {
        countries: [
            'AT',
            'AU',
            'BE',
            'C2',
            'CH',
            'CN',
            'DE',
            'DK',
            'ES',
            'FR',
            'GB',
            'AZ',
            'BI',
            'BN',
            'BT',
            'BY',
            'CD',
            'CG',
            'CI',
            'CK',
            'CM',
            'DJ',
            'ER',
            'FM',
            'GA',
            'GH',
            'GW',
            'KH',
            'KI',
            'KM',
            'KZ',
            'LA',
            'LK',
            'MD',
            'ME',
            'MH',
            'MK',
            'MN',
            'MR',
            'MU',
            'MV',
            'NE',
            'NF',
            'NG',
            'NP',
            'NR',
            'NU',
            'PN',
            'PY',
            'RW',
            'SB',
            'SJ',
            'SL',
            'SN',
            'SO',
            'ST',
            'TD',
            'TO',
            'TV',
            'UA',
            'VG',
            'VU',
            'WF',
            'WS',
            'YE',
            'ZW',
            'VA',
            'YT',
            'AD',
            'AE',
            'AL',
            'AM',
            'AO',
            'BA',
            'BF',
            'BH',
            'BJ',
            'BW',
            'CV',
            'DZ',
            'ET',
            'FJ',
            'FO',
            'GI',
            'GM',
            'GN',
            'HR',
            'ID',
            'IS',
            'JO',
            'KE',
            'KG',
            'KR',
            'KW',
            'LS',
            'MA',
            'MG',
            'ML',
            'MW',
            'MZ',
            'NA',
            'OM',
            'PF',
            'PG',
            'PW',
            'QA',
            'SA',
            'SC',
            'SZ',
            'TG',
            'TJ',
            'TM',
            'TN',
            'TZ',
            'UG',
            'UY',
            'VN',
            'ZA',
            'ZM',
            'BG',
            'EE',
            'LT',
            'LV',
            'RO',
            'SK',
            'CY',
            'MY',
            'NZ',
            'PH',
            'CZ',
            'FI',
            'GR',
            'HU',
            'LI',
            'LU',
            'MT',
            'PT',
            'RE',
            'SI',
            'SM',
            'HK',
            'IE',
            'IL',
            'IN',
            'IT',
            'JP',
            'NL',
            'NO',
            'PL',
            'EG',
            'GE',
            'MC',
            'RS',
            'RU',
            'SE',
            'SG',
            'TH',
            'TR',
            'TW',
        ],
    },
    showDisclaimer: {
        countries: [
            'C2',
            'CH',
            'CN',
            'AZ',
            'BI',
            'BN',
            'BT',
            'BY',
            'CD',
            'CG',
            'CI',
            'CK',
            'CM',
            'DJ',
            'ER',
            'FM',
            'GA',
            'GH',
            'GW',
            'KH',
            'KI',
            'KM',
            'KZ',
            'LA',
            'LU',
            'LK',
            'MD',
            'ME',
            'MH',
            'MK',
            'MN',
            'MR',
            'MU',
            'MV',
            'NE',
            'NF',
            'NG',
            'NP',
            'NR',
            'NU',
            'PN',
            'PY',
            'RW',
            'SB',
            'SJ',
            'SL',
            'SN',
            'SO',
            'ST',
            'TD',
            'TO',
            'TV',
            'UA',
            'VG',
            'VU',
            'WF',
            'WS',
            'YE',
            'ZW',
            'AD',
            'AE',
            'AL',
            'AM',
            'AO',
            'BA',
            'BF',
            'BH',
            'BJ',
            'BW',
            'CV',
            'DZ',
            'ET',
            'FJ',
            'FO',
            'GI',
            'GM',
            'GN',
            'HR',
            'ID',
            'IS',
            'JO',
            'KE',
            'KG',
            'KR',
            'KW',
            'LS',
            'MA',
            'MG',
            'ML',
            'MW',
            'MZ',
            'NA',
            'OM',
            'PF',
            'PG',
            'PW',
            'QA',
            'SA',
            'SC',
            'SZ',
            'TG',
            'TJ',
            'TM',
            'TN',
            'TZ',
            'UG',
            'UY',
            'VN',
            'ZA',
            'ZM',
            'CY',
            'MY',
            'NZ',
            'PH',
            'HK',
            'IL',
            'IN',
            'JP',
            'EG',
            'GE',
            'MC',
            'RS',
            'SG',
            'TH',
            'TW',
        ],
    },
    countrySpecificDisclaimer: ['HK', 'IN', 'SG', 'JP'],
    links: {
        contact: '/smarthelp/contact-us',
        privacy: '/webapps/mpp/ua/privacy-full',
        legal: '/legalhub/home',
        worldwide: '/webapps/mpp/country-worldwide',
        about: '/webapps/mpp/about',
        home: '/home',
        terms: '/webapps/mpp/ua/legalhub-full',
        termsIN: '/webapps/mpp/ua/useragreement-full',
        policy: '/webapps/mpp/ua/upcoming-policies-full',
    },
};
export default config;
